import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

interface NavigationContextValue {
  panelId: string | null;
  companyId: string | null;
  setLastCompanyId: (companyId: string) => void;
  setPanelContext: (panelId: string, companyId?: string) => void;
}

const NavigationContext = createContext<NavigationContextValue | undefined>(
  undefined
);

export const NavigationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [panelId, setPanelId] = useState<string | null>(null);
  const [companyId, setCompanyId] = useState<string | null>(null);

  const setLastCompanyId = useCallback((newCompanyId: string) => {
    setCompanyId(newCompanyId || null);
  }, []);

  const setPanelContext = useCallback(
    (newPanelId: string, newCompanyId?: string) => {
      setPanelId(newPanelId);
      if (newCompanyId) setCompanyId(newCompanyId);
    },
    []
  );

  return (
    <NavigationContext.Provider
      value={{ panelId, companyId, setLastCompanyId, setPanelContext }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = (): NavigationContextValue => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error(
      'useNavigationContext must be used within a NavigationContextProvider'
    );
  }
  return context;
};
